import React, { useEffect, useState } from 'react'
import s from './FeatureTogglePanel.module.sass'
import { Text } from '@shared/ui/Typography/Text'
import { useFeatureToggle } from '@app/PageLayout/handlers/useFeatureToggle'
import useIsDev from '@shared/lib/hooks/useIsDev'

/**
 * @function FeatureTogglePanel - компонент включающий разные функции приложения
 * @description по умолчанию скрыт, нажимаем сочетание Ctrl/Cmd + Shift + F
 */
export const FeatureTogglePanel = () => {
  const [visible, setVisible] = useState(false)
  const { flags: featureFlags, toggleFeatureFlag } = useFeatureToggle()
  const isDevEnvironment = useIsDev()
  // Обработчик сочетания клавиш
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      // Ctrl/Cmd + Shift + F
      if ((e.ctrlKey || e.metaKey) && e.shiftKey && e.code === 'KeyF') {
        e.preventDefault()
        setVisible((prev) => !prev)
      }
    }

    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [])

  if (!visible || !isDevEnvironment) return null

  return (
    <div className={s.panel}>
      <Text sizes={'L'} medium className={s.title}>
        Управление фичами
      </Text>

      <ul className={s.list}>
        {Object.entries(featureFlags).map(([featureName, isEnabled]) => (
          <li key={featureName} className={s.item} data-feature-active={isEnabled}>
            <label className={s.label}>
              <div className={s.status}></div>

              <input
                type='checkbox'
                checked={isEnabled}
                onChange={() => toggleFeatureFlag(featureName as keyof typeof featureFlags)}
                className={s.checkbox}
              />

              <Text sizes={'M'} className={s.text}>
                {featureName}
              </Text>
            </label>
          </li>
        ))}
      </ul>

      <Text sizes={'S'} className={s.description}>
        Скрыть/показать панель: Ctrl/Cmd + Shift + F
      </Text>
    </div>
  )
}
